// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__2Co4K","info":"Note_info__2Mgh3","note":"Note_note__2kdSG","actions":"Note_actions__3Yvw-"};